import cx from 'classnames';

import { type VideoBlock as VideoBlockType } from '../../landingPages/@types/landingPages';
import { getYouTubeEmbedUrl } from '../../landingPages/Components/ContentBlock/ContentBlock.helpers';
import { landingPageSectionLoadEvent, PAGE_SECTIONS } from '../../landingPages/Pages/LandingPage.helpers';
import { usePageRefEvents } from '../Hooks/usePageRefEvents';
import { RoundedSection } from '../RoundedSection/RoundedSection';

import styles from './VideoBlock.scss';

export const VideoBlock = (block: VideoBlockType) => {
  const onRefTrigger = () => landingPageSectionLoadEvent(PAGE_SECTIONS.VIDEO);

  const { setRef } = usePageRefEvents({ onRefTrigger });

  const embedUrl = getYouTubeEmbedUrl(block.video);

  return (
    <RoundedSection withBottomLedge withTopLedge theme={block.theme}>
      <div ref={(ref) => setRef(ref)} className={cx(styles.component, {
        [styles.row]: block.layout === 'row',
      })} data-testid="videoBlock">
        {block.block_title && <h2 className={styles.title}>{block.block_title}</h2>}
        <div className={styles.video}>
          {embedUrl && (
            <iframe
              allowFullScreen
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              data-testid="youtube-vid-player"
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              src={embedUrl}
              title={block.block_title || 'Video'}
            />
          )}
        </div>
        {block.content ? <div dangerouslySetInnerHTML={{ __html: block.content }} className={styles.content}/> : null}
      </div>
    </RoundedSection>
  );
};
